var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"readonly":"","value":_vm.getIngredientsAllergens.join(', '),"outlined":"","hide-details":"","prepend-icon":"fa-notes-medical"}})}
var staticRenderFns = []

export { render, staticRenderFns }